import { GetServerSideProps, NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import dynamic from 'next/dynamic';
import { useAppDispatch } from '@/redux';

const CategViewWB = dynamic(() => import('@/components/views/CategViewWB'));
CategViewWB.displayName = 'CategViewWB';
const CategView = dynamic(() => import('@/components/views/CategView'));
CategView.displayName = 'CategView';
const CategViewCU = dynamic(() => import('@/components/views/CategViewCU'));
CategViewCU.displayName = 'CategViewCU';
const ProductView = dynamic(() => import('@/components/views/ProductView'));
ProductView.displayName = 'ProductView';
const LandingView = dynamic(() => import('@/components/views/LandingView'));
LandingView.displayName = 'LandingView';
const CategListingView = dynamic(() => import('@/components/views/CategListingView'));
CategListingView.displayName = 'CategListingView';
const CustomerLoyaltyView = dynamic(() => import('@/components/views/CustomerLoyaltyView'));
CustomerLoyaltyView.displayName = 'CustomerLoyaltyView';

import { initializeStore } from '@/redux/initialize-store';
import { getSlugServerSideProps } from '@/utils/slugUtils';
import { PAGES } from '@/constants/pages';

interface SlugPageProps {
  componentType: keyof typeof PAGES;
  props: { [key: string]: any };
}

export const SeoPage: NextPage<SlugPageProps> = ({ componentType, ...props }) => {
  const viewProps: any = { ...props };
  const dispatch = useAppDispatch();

  switch (componentType) {
    case PAGES.CATEG_WB:
      return <CategViewWB {...viewProps} />;
    case PAGES.CATEG_CU:
      return <CategViewCU {...viewProps} />;
    case PAGES.CATEG:
      return <CategView {...viewProps} />;
    case PAGES.PRODUCT:
      return <ProductView {...viewProps} />;
    case PAGES.LANDING_PAGE:
      return <LandingView {...viewProps} />;
    case PAGES.CATEG_LISTING:
      return <CategListingView {...viewProps} />;
    case PAGES.CUSTOMER_LOYALTY:
      return <CustomerLoyaltyView {...viewProps} />;
  }

  console.debug('SeoPage: unknown component type', componentType);
  return null;
};

export const getServerSideProps: GetServerSideProps<SlugPageProps> = (async (ctx) => {
  const startTime = Date.now();
  const store = initializeStore({ ssrContext: ctx });
  const res: any = await getSlugServerSideProps(ctx, store, serverSideTranslations);
  if (res?.props?.layoutOptions?.redirect && store.getState().root.storeConf.privateWebsite) {
    return {
      redirect: res.props.layoutOptions.redirect,
    };
  }
  const endTime = Date.now();
  const executionTime = endTime - startTime;
  console.log(`Temps d'exécution de 'GetServerSideProps': ${executionTime} ms`);
  return res;
});

export default SeoPage;
